import { Vault } from '../vault/vault';
export class KeyVaultService {
    constructor(uiFrameAdapter, vaultRepository, logger) {
        this.uiFrameAdapter = uiFrameAdapter;
        this.vaultRepository = vaultRepository;
        this.logger = logger;
    }
    async getKeyVault() {
        const vaultEntriesResponse = await this.vaultRepository.loadVaultEntries(this.uiFrameAdapter.companyId);
        const vault = await Vault.Create(vaultEntriesResponse.entries, vaultEntriesResponse.cachedEntryCount);
        if (vaultEntriesResponse.entries.length === 0 || vaultEntriesResponse.entries.length !== vaultEntriesResponse.cachedEntryCount) {
            try {
                this.vaultRepository.saveVaultEntriesInLocalStorage(this.uiFrameAdapter.companyId, vault.entries);
            }
            catch (ex) {
                this.logger.logWarning(`Key Vault Service: ${ex}`);
            }
        }
        return vault;
    }
    async addVaultEntry(entry) {
        return await this.vaultRepository.addVaultEntry(entry);
    }
    async addVaultEntries(entries) {
        return await this.vaultRepository.addVaultEntries(entries);
    }
}
